import { render, staticRenderFns } from "./Arenas.vue?vue&type=template&id=726e2f28&"
import script from "./Arenas.vue?vue&type=script&lang=js&"
export * from "./Arenas.vue?vue&type=script&lang=js&"
import style0 from "./Arenas.vue?vue&type=style&index=0&id=726e2f28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports